import { useCallback } from 'react';

import { Suggestion } from '@/components/LyearnAI/hooks/useQuestionOptions';
import { OnDropParams } from '@/modules/corporate/components/DraggableList/types';
import useOptionsAction from '@/modules/corporate/modules/questions/fields/hooks/useOptionsAction';
import { QuizOptionsActionEnum } from '@/modules/corporate/modules/questions/fields/hooks/useOptionsAction/actions';
import { QuestionEditorProps } from '@/modules/corporate/modules/questions/fields/types';

const useEditorOptionsList = (
  props: Pick<QuestionEditorProps, 'question' | 'onChange' | 'isMultiSelect'> & {
    variant?: 'quiz' | 'survey';
  },
) => {
  const { options, onAction } = useOptionsAction(props);

  const onAddOption = useCallback(() => {
    onAction({ type: QuizOptionsActionEnum.AddOption });
  }, [onAction]);

  const onAddSuggestions = useCallback(
    (suggestions: Suggestion[]) => {
      onAction({
        type: QuizOptionsActionEnum.AddOptions,
        payload: {
          newOptions: suggestions.map((suggestion) => ({
            optionText: suggestion.questionOption,
            optionEvaluation: false,
          })),
        },
      });
    },
    [onAction],
  );

  const onDrop = useCallback(
    ({ fromIndex, toIndex }: OnDropParams) => {
      onAction({
        type: QuizOptionsActionEnum.ReorderOption,
        payload: { fromIndex, toIndex },
      });
    },
    [onAction],
  );

  return { options, onAction, onAddOption, onDrop, onAddSuggestions };
};

export default useEditorOptionsList;
